import { createEntityAdapter,EntityState } from '@ngrx/entity';
import { createReducer,on } from '@ngrx/store';
import { TaxTypeEntity } from '../../entities/tax-type.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { TaxTypeActions } from '../actions/tax-type.actions';

export const TAX_TYPE_FEATURE_KEY = 'taxType';

export interface TaxTypeState extends EntityState<TaxTypeEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<TaxTypeEntity>({
    selectId: Entity => Entity.Id,
});

const initialState: TaxTypeState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const taxTypeReducer = createReducer(
    initialState,
    on(TaxTypeActions.loadSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
            fetched: true,
            // latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTaxType = selectAll;
export const selectTaxTypeEntities = selectEntities;

export const selectTaxTypeFetched = (state: TaxTypeState) => state.fetched;
// export const selectTaxTypeLatestUpdatedAt = (state: TaxTypeState) => state.latestUpdatedAt;
